/**
 * Adminbar Class
 *
 * Shrinks the WordPress adminbar to a small, absolutely positioned box in the top left of the page which opens up to
 * the normal adminbar on hover and closes 1200 ms after the cursor left the adminbar
 *
 * v1.6 - 24.02.11 - preventing errors when adminbar not found
 * v1.5 - 23.10.06 - converted to module class, removed jQuery dependency
 *
 */

import m3_getQueryVariable from "../tools/m3-tools.js";

class I96Adminbar {

    constructor(config) {

        this.debug = typeof m3_getQueryVariable == 'function' ? m3_getQueryVariable('debug-adminbar') : false;

        const settings_default = {
            open: false,
            timeout: null,
            closeDelay: 1200,

            initTimeout: null,
            initCount: 0,
            initMax: 50,
            initDelay: 100
        };

        this.settings = {
            ...settings_default,
            ...config
        }

        // waiting for the adminbar to appear
        this.settings.initTimeout = setInterval( () => {
            if (document.getElementById('wpadminbar')) {
                this.setup();
                clearInterval(this.settings.initTimeout);
            } else {
                if (this.debug) console.log('I96Adminbar: initTimeout - nope' + this.settings.initCount);
                this.settings.initCount += 1;
                if (this.settings.initCount > this.settings.initMax)
                    clearInterval(this.settings.initTimeout);
            }
        }, this.settings.initDelay);

    }


    setup() {

        // removing the margin for the adminbar
        document.querySelector(':root').setAttribute('style', 'margin-top: 0 !important');
        const body_adminbar = document.querySelector('body.admin-bar');
        if (body_adminbar) {
            body_adminbar.setAttribute('style', 'max-height: inherit');
        }

        const adminbar = document.getElementById('wpadminbar');

        if (adminbar) {
            // MOUSE LEAVE
            // --------------------------------------------
            adminbar.addEventListener('mouseleave', (e) => this._onMouseLeave(e));

            // MOUSE ENTER
            // --------------------------------------------
            adminbar.addEventListener('mouseenter', (e) => this._onMouseEnter(e));
        }

        this._showDebug();
    }

    _onMouseEnter(ev) {

        if (this.settings.timeout != null) {
            clearTimeout(this.settings.timeout);
            this.settings.timeout = null;
        }

        if (!this.settings.open) {
            console.log(ev);
            ev.target.classList.add('-open');
            this.settings.open = true;
        }

        this._showDebug();
    }

    _onMouseLeave(ev) {

        if (this.settings.timeout != null) {
            clearTimeout(this.settings.timeout);
            this.settings.timeout = null;
        }

        this.settings.timeout = setTimeout(() => {
            ev.target.classList.remove('-open');
            this.settings.open = false;
            this.settings.timeout = null;
            this._showDebug();
        }, this.settings.closeDelay);

        this._showDebug();
    }

    _showDebug() {
        // todo: deal with multiple i96 debug windows open
        if (this.debug) {
            let debugel = document.getElementById('i96-admin-debug')
            if (!debugel) {
                var newNode = document.createElement('div');
                newNode.id = 'i96-admin-debug';
                // add class i96-debug-window
                newNode.style.background = '#c0e3c0'
                newNode.style.position = 'fixed'
                // check for open debug windows and align accordingly
                newNode.style.top = '200px'
                newNode.style.left = '1rem'
                newNode.style.fontSize = '0.7rem'
                newNode.style.lineHeight = '1'
                newNode.style.padding = '0.5rem 1rem'
                document.body.appendChild(newNode);
                debugel = document.getElementById('i96-admin-debug')
            }
            let str = '<b style="min-width:64px;display:inline-block;">ADMINBAR > </b><br>';
            // str += '<b style="min-width:64px;display:inline-block;">' + ele + '</b>' + this.scroll_data.pos[ele] + '<br>'
            Object.keys(this.settings).forEach( ele => {
                str += '<b style="min-width:64px;display:inline-block;">' + ele + '</b>' + this.settings[ele] + '<br>'
            })
            debugel.innerHTML = str
        }
    }

}

export default I96Adminbar
